export default __webpack_public_path__ + "static/media/scratchCardImage.67ed9cf7.png";